/**
 * Confirmación antes de quitar una serie del pickeo (por si la unidad va en
 * otro remito). Lo usan la tabla de partidas del detalle y la lista del modal
 * "Pickear". Quitar cancela en el back: CANCELACION_PICKING y, si la reserva
 * fue del pickeo, LIBERACION_RESERVA.
 */

import { Trash2 } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirmar: () => void;
  articulo: string | null;
  lote: string | null;
  serie: string;
}

export function ConfirmarQuitarPickeoDialog({
  open,
  onOpenChange,
  onConfirmar,
  articulo,
  lote,
  serie,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Quitar serie del pickeo</DialogTitle>
          <DialogDescription className="text-xs">
            La unidad deja de estar pickeada para este remito y queda disponible para pickearla en el
            que corresponda.
          </DialogDescription>
        </DialogHeader>
        <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-xs">
          <dt className="text-gray-500">Artículo</dt>
          <dd>{articulo ?? '—'}</dd>
          <dt className="text-gray-500">Lote</dt>
          <dd className="font-mono">{lote ?? '—'}</dd>
          <dt className="text-gray-500">N° de serie</dt>
          <dd className="font-mono font-semibold">{serie}</dd>
        </dl>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button
            className="bg-red-600 text-white hover:bg-red-700"
            onClick={() => {
              onOpenChange(false);
              onConfirmar();
            }}
          >
            <Trash2 className="mr-1 h-4 w-4" />
            Quitar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
